// Turbo pageview tracking for GTM
// Pushes turbo_pageview events to dataLayer on Turbo Drive navigation
//
// GTM must have a trigger for "turbo_pageview" custom event that fires
// a GA4 page_view tag. This ensures proper Conversion Linker integration.
//
// Note: We only push to dataLayer, not direct gtag calls. GTM controls
// all GA4 tracking to maintain attribution chain integrity.

const TURBO_PAGEVIEW_EVENT = "turbo_pageview"
const TURBO_LOAD_EVENT = "turbo:load"

let isInitialLoad = true

function trackPageView() {
  // Skip initial page load (GTM's GA4 config tag handles it)
  if (isInitialLoad) {
    isInitialLoad = false
    return
  }

  // Initialize dataLayer if it doesn't exist (events will queue for when GTM loads)
  window.dataLayer = window.dataLayer || []

  window.dataLayer.push({
    event: TURBO_PAGEVIEW_EVENT,
    page_path: window.location.pathname,
    page_location: window.location.href,
    page_title: document.title
  })
}

// Listen for Turbo Drive navigation (not Turbo Frames - they don't fire turbo:load)
document.addEventListener(TURBO_LOAD_EVENT, trackPageView)

export {}
